document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".product__photo-container");

  containers.forEach(container => {
    const img = container.querySelector("img");
    let zoomed   = false;
    let frameId  = null;
    let lastX    = 0,
        lastY    = 0;

    // update transform-origin once per rAF
    function update() {
      const rect = img.getBoundingClientRect();
      const xPct = ((lastX - rect.left)  / rect.width)  * 100;
      const yPct = ((lastY - rect.top)   / rect.height) * 100;
      img.style.transformOrigin = `${xPct}% ${yPct}%`;
      frameId = null;
    }

    // capture pointer moves
    function pointerMoveHandler(e) {
      if (e.type === "touchmove") e.preventDefault();
      const p = e.touches ? e.touches[0] : e;
      lastX = p.clientX;
      lastY = p.clientY;
      if (!frameId) frameId = requestAnimationFrame(update);
    }

    // cleanup on next click
    function cleanupZoom() {
      if (!zoomed) return;
      zoomed = false;
      img.style.transformOrigin = "";
      container.classList.remove("zoomed");
      document.removeEventListener("mousemove", pointerMoveHandler);
      document.removeEventListener("touchmove", pointerMoveHandler);
      if (frameId) {
        cancelAnimationFrame(frameId);
        frameId = null;
      }
    }

    container.addEventListener("click", e => {
      if (e.target.tagName !== "IMG") return;

      if (!zoomed) {
        // activate zoom
        zoomed = true;
        container.classList.add("zoomed");

        document.addEventListener("mousemove", pointerMoveHandler);
        document.addEventListener("touchmove", pointerMoveHandler, { passive: false });

        // init origin
        const p = e.touches ? e.touches[0] : e;
        lastX = p.clientX;
        lastY = p.clientY;
        update();

        // wait until after this click bubbles, then listen once for the next click anywhere
        setTimeout(() => {
          document.addEventListener("click", cleanupZoom, { once: true });
        }, 0);
      }
      // if zoomed was true and user clicked image again, cleanupZoom will fire via the once-listener
    });
  });
});
